export interface ConfigItem {
  titleTranslationKey: string;
  iconClass: string;
  routerLink?: string;
  permission: string | string[];
  callback?: () => any;
  disabled?: boolean;
}
